import "./auth.scss";
import { Form, Toast } from "react-bootstrap";
import InputForm from "../command/input/inputField";
import { Link, useNavigate } from "react-router-dom";
import Button from "../command/Button/Button";
import AuthMainTitle from "../command/authMainTitle/authMainTitle";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { userClient } from "../../data/user";
import { useEffect, useState } from "react";
import OptOutModal from "./optOutModal";
import OtpFormModal from "./otpFormModal";
//import NotificationModal from "../command/notificationModal/notificationModal";
import DiscountMismatchModal from "../command/discountMismatchModal/discountMismatchModal";
import {
  setAuthCredentials,
  getAuthCredentials,
  deleteCookie,
  AUTH_CRED,
  getIdvBypass,
} from "../../utils/auth-utils";
import { Effect } from "../../assets/svgIcon/customIcon";
import { useAuth } from "../../contexts/authContext";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import ToastMessage from "../command/toast/toastMessage";
import { productDetailsClient } from "../../data/product-details";
import { toast } from "react-toastify";

const loginFormSchema = yup.object().shape({
  email: yup
    .string()
    .email("Email format is invalid")
    .required("Email is required"),
  password: yup.string().when("emailExists", {
    is: true,
    then: () => yup.string().required("Password is required"),
    otherwise: () => yup.string(),
  }),
});

interface OwnItPricing {
  discountPercentage: number;
  purchasePrice: number;
  // Add other ownItPricing properties if needed
}

interface quote {
  orderAmount: number;
  serviceCharge: number;
  deliveryCharge: number;
  totalDepositAmount: number;
  deliveryMethod: string;
  deliveryAndCollectionCharge: number;
  instoreCollectionCharge: number;
  rentalStartDate: any;
  rentalEndDate: any;
  rentalType: any;
  retailerUuid: any;
  storeUuid: any;
  rentalDuration: any;
  canConvertedToPurchaseAfterRent?: boolean;
  ownItPricing?: OwnItPricing;
  discountCode?: string;
  discountAmount?: number;
  totalQuoteValue?: any;
}

const LoginForm = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    watch,
    getValues,
    clearErrors,
    setValue,
  } = useForm({
    resolver: yupResolver(loginFormSchema),
    mode: "all",
  });
  const [emailExists, setEmailExists] = useState(false);
  const [defaultEmail] = useState(localStorage.getItem("email"));
  const [optOutModal, setOptOutModal] = useState(false);
  const [otpModalShow, setOtpModalShow] = useState(false);
  const [emailValue, setEmailValue] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [checkingEmail, setCheckingEmail] = useState(false);
  const [discountCodeModal, setDiscountCodeModal] = useState(false);
  const [quote, setQuote] = useState<quote>();
  const watchEmail = watch("email");
  const watchPassword = watch("password", "");
  const { login, setSignUpEmail } = useAuth();
  const { bypassIDV, maximumOrderValue, disableIDV } = getIdvBypass();

  // const [showToast, setShowToast] = useState(false);
  // const [toastMessage, setToastMessage] = useState('');
  // const [toastType, setToastType] = useState('');
  const { quoteId, customerUuid } = getAuthCredentials();

  const checkEmailExists = async (fromModal?: boolean) => {
    setCheckingEmail(true);
    try {
      let requestPayload = {};
      if (!fromModal && quote?.discountCode) {
        requestPayload = {
          username: getValues("email"),
          discountCode: quote?.discountCode,
          quoteUuid: quoteId,
        };

      } else {
        requestPayload = {
          username: getValues("email"),
        };
      }
      const response = await userClient.verifyEmailAddress(requestPayload);
      if (!fromModal && !response.allowCheckout && quote?.discountCode) {
        setDiscountCodeModal(true);
      } else if (response.isExists && response.isPasswordSet) {
        setEmailExists(response.isExists);
        localStorage.removeItem("email");
      } else if ((bypassIDV || disableIDV) && response.isExists && !response.isPasswordSet && response.validateUser) {
        sendOtp();
      } else if ((bypassIDV || disableIDV) && response.isExists && !response.validateUser) {
        localStorage.setItem("email", getValues("email"));
        setSignUpEmail(getValues("email"));
        navigate("/signup", { state: { toLogin: true } });
      } else if (response.isExists && response.isMobileVerified && !response.isPasswordSet) {
        // Call login API for verified users without password
        try {
          setLoading(true);
          const request = {
            username: getValues("email"),
            password: "",
            userTypeId: 6,
            customerQuoteUuid: quoteId
          };

          const res = await userClient.initiateLogin(request);
          if (res.success) {
            const decodedToken: any = jwtDecode(res.data.access_token);
            deleteCookie(AUTH_CRED);
            if (decodedToken) {
              const customerUuid = decodedToken?.uuid;
              const userUuid = decodedToken?.userUuid;
              const countryCode = decodedToken?.countryCode;
              const isInternational = decodedToken?.isInternational;

              setAuthCredentials(
                res.data.access_token,
                res.data.refresh_token,
                customerUuid,
                userUuid,
                null,
                countryCode,
                isInternational
              );
              login();
              // await customerQuteUpdate(userUuid);

              if (disableIDV || decodedToken?.isKYCVerified) {
                navigate("/information-capture");
              } else {
                navigate("/verify-identity");
              }
            } else {
              console.log("Customer Uuid not set");
            }
          } else {
            toast.error(res.error);
          }
        } catch (error: any) {
          toast.error(error?.message);
        } finally {
          setLoading(false);
        }
      } else if (response.isExists && response.isMobileVerified && response.isPasswordSet) {
        setEmailExists(response.isExists);
        localStorage.removeItem("email");
      } else {
        localStorage.setItem("email", getValues("email"));
        setSignUpEmail(getValues("email"));
        navigate("/signup");
      }
    } catch (error) {
      setEmailExists(false);
      console.error("Error checking email:", error);
    } finally {
      setCheckingEmail(false);
    }
    return false;
  };

  const handleEmailSubmit = async () => {
    const email = getValues("email");
    if (email && !errors.email) {
      await checkEmailExists();
    }
  };

  const handleFinalSubmit = async (values: any) => {
    setLoading(true);
    setError("");
    const request = {
      username: values.email,
      password: values.password,
      userTypeId: 1,
      customerQuoteUuid: quoteId,
    };
    try {
      const res = await userClient.initiateLogin(request);
      if (res.success) {
        const decodedToken: any = jwtDecode(res.data.access_token);
        deleteCookie(AUTH_CRED);
        if (decodedToken) {
          const customerUuid = decodedToken?.uuid;
          const userUuid = decodedToken?.userUuid;
          const countryCode = decodedToken?.countryCode;
          const isInternational = decodedToken?.isInternational;

          setAuthCredentials(
            res.data.access_token,
            res.data.refresh_token,
            customerUuid,
            userUuid,
            null,
            countryCode,
            isInternational
          );
          login();
          // toast.success("Customer Logged Sucessfully");
          // setToastMessage('Customer Logged Sucessfully');
          // setShowToast(true);
          // setToastType('success')
          console.log("decodedToken isKYCVerified :: ", decodedToken);
          // await customerQuteUpdate(userUuid);

          if (disableIDV || decodedToken?.isKYCVerified) {
            navigate("/information-capture");
          } else {
            navigate("/verify-identity");
          }
        } else {
          console.log("Customer Uuid not set");
        }
      } else {
        toast.error(res.error);
        // setToastMessage(res.error);
        // setToastType('danger')
        // setShowToast(true);
      }
    } catch (error: any) {
      toast.error(error?.message);
      // setToastMessage(error.message);
      // setToastType('danger')
      // setShowToast(true);
    } finally {
      setLoading(false);
    }
  };

  const sendOtp = async () => {
    const email = getValues("email");
    setEmailValue(email);

    const request = {
      username: email,
      userTypeId: 6,
    };

    try {
      const res: any = await userClient.forgetPassword(request);
      if (res?.success) {
        setOtpModalShow(true);
        toast.success(`${t("sent-verification-code")} ${request.username}`);
      } else {
        toast.error("Something went wrong");
      }
    } catch (error: any) {
      toast.error("Something went wrong");
    }
  };

  const handleOtpVerification = (verified: boolean) => {
    if (verified) {
      setOtpVerified(true);
      setOtpModalShow(false);
      toast.success(t("otp-verification-successful"));
      // After successful OTP verification, navigate to information capture
      navigate("/information-capture");
    }
  };

  const customerQuteUpdate = (customerid: string) => {
    setLoading(true);
    const value = {
      customerQuoteUuid: quoteId,
      customerUuid: customerid,
    };
    productDetailsClient
      .updateCustomerQuote(value)
      .then((data: any) => {
        setLoading(false);
      })
      .catch((error: any) => {
        toast.error(error?.message);
        // setShowToast(true);
        // setToastMessage(error?.message)
        // setToastType('danger');
        setLoading(false);
      });
  };


  useEffect(() => {
    if (quoteId) {
      productDetailsClient
        .getProductDetailsList({ quoteUuid: quoteId })
        .then((data: any) => {
          // setData(data.products);
          setQuote(data.quote);
          setLoading(false);
        })
        .catch((error: any) => {
          toast.error(error.message);
          setError(error.message);
          setLoading(false);
        });
    }
  }, [quoteId]);

  useEffect(() => {
    if (defaultEmail != null) {
      setValue("email", defaultEmail, { shouldValidate: true });
    }
  }, [defaultEmail, setValue]);

  useEffect(() => {
    if (watchEmail) {
      clearErrors("email");
      setEmailExists(false);
    }
  }, [watchEmail, clearErrors]);
  return (
    <>
      <div className="login-form-section">
        <div className="effect-add-section auth-page-effect">
          <Effect className="effect-img" />
          <AuthMainTitle
            mainTitleText={t("lets-get-started")}
            className="login-title"
          />
          <Form
            onSubmit={handleSubmit(
              emailExists ? handleFinalSubmit : handleEmailSubmit
            )}
          >
            <InputForm
              inputId="login-email"
              inputLable={t("input-label-email")}
              inputType="email"
              inputPlaceholder={t("auth-email-placeholder")}
              register={register("email")}
              error={errors?.email?.message}
              // onBlur={handleEmailBlur}
              // onFocus={handleEmailFocus}
              // inputChecked={emailExists}
              required
            />
            {/* Password Field */}
            {/* Forgot password? Link */}
            {emailExists && (
              <>
                <InputForm
                  inputId="login-password"
                  inputLable={t("input-label-password")}
                  inputType="password"
                  inputPlaceholder={t("input-label-password")}
                  register={register("password", { required: true })}
                  error={errors?.password?.message}
                  required
                />
                <div className="forgot-link-box">
                  <Link
                    to={"/forgotpassword"}
                    className="auth-link forgot-link"
                  >
                    {t("forgot-password")}
                  </Link>
                </div>
              </>
            )}
            <div className="form-btn-section">
              {error && <p className="error-message">{error}</p>}
              <Button
                btnText={t("continue")}
                type="submit"
                disabled={
                  !isValid ||
                  checkingEmail ||
                  loading ||
                  (emailExists && !watchPassword)
                }
              />
              <p className="privacy-policy-text">
                {t("privacy-policy-text-one")}{" "}
                <Link
                  to={"https://www.renticy.com/privacy-policy/"}
                  target="_blank"
                  className="policy-link"
                >
                  {t("privacy-policy")}
                </Link>
                . {t("privacy-policy-text-two")}.{" "}
                {t("privacy-policy-text-three")}{" "}
                <Link
                  to={"#"}
                  onClick={() => setOptOutModal(true)}
                  className="policy-link"
                >
                  {t("opt-out")}
                </Link>{" "}
                {t("privacy-policy-text-four")}.
              </p>
            </div>
          </Form>
        </div>
      </div>

      {/*  */}
      <OptOutModal
        show={optOutModal}
        optOutHide={() => setOptOutModal(false)}
      />

      <DiscountMismatchModal
        show={discountCodeModal}
        notificationHide={() => {
          setDiscountCodeModal(false);
        }}
        notificationOk={async () => {
          await productDetailsClient.removePromoCode({
            quoteUuid: quoteId,
          });
          toast.success("Discount code removed");
          checkEmailExists(true);
          setDiscountCodeModal(false);
        }}
        notificationtitle={t("discount-not-valid")}
        notificationtext={t("discount-validation-message")}
        submitButtonText={t("remove-discount-code")}
        cancelButtonText={t("enter-new-email")}
        email={getValues("email")}
        couponCode={quote?.discountCode}
      />

      <OtpFormModal
        show={otpModalShow}
        username={`${getValues("email")}`}
        onHide={() => setOtpModalShow(false)}
        onValueChange={handleOtpVerification}
        byPassIDV={true}
      />

      {/* <ToastMessage show={showToast} message={toastMessage} onClose={() => setShowToast(false)} type={toastType} /> */}
    </>
  );
};

export default LoginForm;
